import React, { useState } from "react";
import AddComment from "../../../../components/individual-session/AddComment";
import ReviewDescription from "../../../../components/individual-session/ReviewDescription";
import { FlagIcon } from "@heroicons/react/outline";
import { useTranslation } from "react-i18next";
import { showApiErrorMessages } from "../../../../helpers";
import { useParams } from "react-router-dom";
import { getSessionCommentsData } from "../../../../api/endpoints/supervisors/sessions";
import { CommentType } from "../../../../api/@types/globalTypes";
import { useQuery } from "react-query";
import ReportSession from "../../../../components/modal/views/ReportSession";
import SessionModel from "../../../../api/models/SessionModel";
import { ApiCommonParams } from "../../../../api/@types/apiTypes";
type CommentsTabProps = {
  session: SessionModel | null;
};
export default function CommentsTab(props: CommentsTabProps) {
  const { session } = props;
  const LocalBasePath = "page.supervisor.sessions";
  const { t } = useTranslation("", { keyPrefix: LocalBasePath });
  const { id } = useParams();
  const [open, setOpen] = useState<boolean>(false);

  const { data: comments, refetch } = useQuery(
    ["commentData", id],
    () => {
      let apiParams: ApiCommonParams = {
        filters: {
          order_by: "-created_at",
        },
      };
      return getSessionCommentsData(id ?? "", apiParams);
    },
    {
      select: (response) => {
        let fetchedComments: CommentType[] = [];
        if (response.isSuccess) {
          fetchedComments = response.data;
          return fetchedComments;
        } else {
          showApiErrorMessages(response);
        }
      },
    }
  );

  return (
    <div className="w-full   p-6  px-4 md:px-6">
      <div className="flex  flex-col gap-6">
        <div className="flex justify-between items-center">
          <p className="font-medium text-base leading-5 text-gray-700">
            {t("supervisorComment")}
          </p>
          <p
            className="text-red-500 text-sm font-medium flex cursor-pointer"
            onClick={() => setOpen(true)}
          >
            {t("sendReport")}
            <FlagIcon className="w-5 h-5 text-red-500" />
          </p>
        </div>
        <AddComment refetch={refetch} />
      </div>
      {!!comments &&
        comments?.length > 0 &&
        comments.map((comment) => (
          <ReviewDescription refetch={refetch} comment={comment} />
        ))}
      <ReportSession open={open} session={session} setOpen={setOpen} />
    </div>
  );
}
